import React from 'react';
import { Box, Button, Grid, Text, Select, TextInput } from '@mantine/core';
import { IconClearAll, IconSearch } from '@tabler/icons-react';
import type { IFiltroCotizacionesVistaProps } from '../interfaces';

const FiltroCotizacionesVista: React.FunctionComponent<IFiltroCotizacionesVistaProps> = ({
  consultarCotizaciones,
  filtro,
  manejarCambioFiltroCotizacion
}) => {
  const opcionesEstado = [
    { value: '', label: 'Todos los estados' },
    { value: 'true', label: 'Aprobadas' },
    { value: 'false', label: 'Pendientes' },
  ];

  return (
    <Box pb="sm">
      <Grid gutter="sm" >
        <Grid.Col span={{ base: 12, md: 2 }}>
          <TextInput
            size='xs'
            label="Repuesto"
            placeholder="Repuesto"
            leftSection={<IconSearch size={12} />}
            value={filtro.Repuesto}
            onChange={(event) => manejarCambioFiltroCotizacion('Repuesto', event.currentTarget.value)}
            style={{ flex: 1 }}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 2 }}>
          <TextInput
            size='xs'
            label="Técnico"
            placeholder="Nombre del técnico"
            value={filtro.TecnicoSolicita}
            onChange={(event) => manejarCambioFiltroCotizacion('TecnicoSolicita', event.currentTarget.value)}
            style={{ minWidth: 200 }}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 2 }}>
          <Select
            size='xs'
            label="Estado"
            placeholder="Seleccione estado"
            data={opcionesEstado}
            value={filtro.Aprobada ? 'true' : filtro.Aprobada === false ? 'false' : ''}
            onChange={(value) => {
              const aprobada = value === 'true' ? true : value === 'false' ? false : undefined;
              manejarCambioFiltroCotizacion('Aprobada', aprobada || false);
            }}
            style={{ minWidth: 150 }}
          />
        </Grid.Col>
        <Grid.Col
          span={{ base: 12, md: 2 }}
          style={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flex-end",
            gap: "0.5rem",
          }}
        >
          <Button
            color="primary"
            variant="light"
            size="compact-sm"
            radius="lg"
            rightSection={<IconClearAll opacity={1} size={12} />}
            onClick={() => {
              manejarCambioFiltroCotizacion('Repuesto', '');
              manejarCambioFiltroCotizacion('TecnicoSolicita', '');
              manejarCambioFiltroCotizacion('Aprobada', false);
            }}
          >
            <Text fw={500} fz={11}>Limpiar</Text>
          </Button>
          <Button
            color="primary"
            variant="filled"
            size="compact-sm"
            radius="lg"
            rightSection={<IconSearch opacity={1} size={12} />}
            onClick={consultarCotizaciones}
          >
           <Text fw={500} fz={11}>Consultar</Text>
          </Button>

        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default React.memo(FiltroCotizacionesVista);
